var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Delete"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    clipPath: "url(#clip-Delete)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon_delete",
    "data-name": "icon delete",
    d: "M1239.475,905.051a2.586,2.586,0,0,1-2.554-2.556c-.272-2.575-.728-8.661-.737-8.723a.731.731,0,0,1,.166-.5.606.606,0,0,1,.455-.209h12.084a.62.62,0,0,1,.456.212.692.692,0,0,1,.158.5c0,.062-.465,6.158-.729,8.722a2.585,2.585,0,0,1-2.614,2.557c-1.125.023-2.227.032-3.316.032C1241.7,905.086,1240.569,905.077,1239.475,905.051Zm-3.849-13.447a.649.649,0,0,1-.622-.664V890.6a.644.644,0,0,1,.622-.664h2.541a1.128,1.128,0,0,0,1.081-.918l.133-.617a1.749,1.749,0,0,1,1.666-1.4h3.6a1.745,1.745,0,0,1,1.655,1.357l.142.66a1.126,1.126,0,0,0,1.081.919h2.541a.643.643,0,0,1,.624.66h0v.344a.649.649,0,0,1-.621.664Z",
    transform: "translate(-1232.845 -886.042)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.80533a314a3420966a3f490c531d5950.svg";
export { ForwardRef as ReactComponent };